export default "__VITE_ASSET__BFT5ntfv__"